import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { Button } from "react-bootstrap";
import { createLogger } from "@/utils/logger";
import styles from "./errorBoundary.module.scss";

const log = createLogger("error-boundary");

function ErrorFallback({ error, resetErrorBoundary }) {
  // Check if it's a chunk loading error
  const isChunkError = 
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Failed to fetch') ||
    error?.name === 'ChunkLoadError';
  
  return (
    <div className={styles.errorContainer}>
      <h1>Something went wrong!</h1>
      {isChunkError ? (
        <div>
          <p>Failed to load page resources. This might be due to a network issue.</p>
          <Button
            className="mt-3 me-2"
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload Page
          </Button>
          <Button
            className="mt-3"
            variant="outline-secondary"
            onClick={() => {
              resetErrorBoundary();
              window.location.replace("/");
            }}
          >
            Go to Home
          </Button>
        </div>
      ) : (
        <>
      <pre className={styles.errorMessage}>{error.message}</pre>
      <Button
        className="mt-5"
        onClick={() => {
          resetErrorBoundary();
          window.location.replace("/");
        }}
      >
        Go to Home
      </Button>
        </>
      )}
    </div>
  );
}

const ErrorBoundary = ({ children }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, errorInfo) => {
        const isChunkError =
          error?.message?.includes('Loading chunk') ||
          error?.name === 'ChunkLoadError';
        log.error(
          {
            error: {
              message: error?.message,
              name: error?.name,
              stack: error?.stack,
              code: error?.code,
            },
            componentStack: errorInfo?.componentStack,
            url: window.location.href,
            // Chunk-load errors are a distinct white-screen cause worth filtering on.
            isChunkError,
          },
          isChunkError
            ? 'Chunk loading error caught by ErrorBoundary (may cause white screens)'
            : 'Error caught by ErrorBoundary',
        );
      }}
      onReset={() => {
        // Reset app state if needed
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
